// ----------------------------------------------------------------------
// <copyright file="Izenda.DynamicColumn.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Dynamic Column component
 */
!(function() {
  var React = require('react');

  function renderDynamic(querySourceTypeDetails) {
    var props = this.props;
    var MESSAGE = this.props.store.getBundle().MESSAGE;

    return (
      <input
        type='checkbox'
        checked={querySourceTypeDetails.isDynamic()}
        disabled={querySourceTypeDetails.isStatic()}
        onChange={updateValue.bind(this)}
      />
    );

    function updateValue(e) {
      var newValue = e.target.checked;
      var setDynamic = function() {
        querySourceTypeDetails.setDynamic(newValue);
      };

      if (!querySourceTypeDetails.isDynamic()) {
        props
          .confirmFn('Confirmation', {
            description: MESSAGE.MG02
          })
          .then(function() {
            setDynamic();
          });
      } else {
        setDynamic();
      }
    }
  }

  module.exports = {
    render: renderDynamic
  };
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/DataModel/QuerySourceType/Izenda.DynamicColumn.jsx